import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import ClientAdd from './ClientAdd';
import PreviewActionPlan from './PreviewActionPlan';
import ParQ from './ParQ';
import SearchInput from './../SearchInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import LoadMoreIcon from './../LoadMoreIcon';
import Search from './../workouts/search';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faTrash, faCheck } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage, paginationLimit } from './../../helpers.js';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import moment from 'moment';

import _ from 'lodash';

const PARQListing = props => {
	const {
		clientEmail,
        fetchPARQS,
        deletePARQ,
        savePARQ,
        isMobile
	} = props;

	const [parqList, setPARQList] = useState([]);
    const [isLoadMore, setLoadMore] = useState(false);
    const [isFetchRes, setFetchRes] = useState(false);
    const [isOpenActionModal, setOpenActionModal] = useState(false);
    const [isOpenEditActionModal, setOpenEditActionModal] = useState(false);
    const [range, setRange] = useState(null);

	useEffect(() => {
	   fetchData(0)
	}, [clientEmail])

    const fetchData = (skip) => {
        fetchPARQS({
            clientEmail,
            skip,
            limit: paginationLimit.TWENTY,
        }).then((res) => {
            const data = Object.values(res);
            let ranges = data[0]['data']
            const metadata = data[0]['metadata']
            if (skip !== 0) {
                ranges = [...parqList, ...ranges]
            }
            let total = 0;
            if (metadata.length && metadata[0]['total']) {
                total = metadata[0]['total'];
            }
            setFetchRes(true);
            setPARQList(ranges);
            setLoadMore(ranges.length < total)

        })

    }

    const viewActionPlan = (range) => {
        setOpenActionModal(true);
        setRange(range);
    }

    const deletePARQData = (id) => {
		if (ConfirmJsMessage(`Are you sure you want to delete this par-q?`)) {
			deletePARQ(id).then(() => {
                setPARQList([])
                setFetchRes(false);
				fetchData(0)
			});
		}
	}

    const renderDate = (date) => {
        return moment(date).utc(0, true).format('MMM DD YYYY');
    }

    const showEditActionMode = (range) => {
        setOpenEditActionModal(true)
        setRange(range)
    }

    const onEditBodyMatrixClose = () => {
        setOpenEditActionModal(false)
    }

    const updateRange = (range) => {
        const findIndex = parqList.findIndex((r) => r._id === range._id);
        if (findIndex > -1) {
            parqList[findIndex] = range;
            setPARQList([...parqList]);
        }
    }

    return (
        <Fragment>
            <div
					style={{
						marginTop: 25,
						display: 'flex',
					}}
				>
            <div style={{ marginBottom: 10, marginTop: 10 }}>
                { isOpenEditActionModal && (
                    <Modal
                    className="modal show"
                    open={isOpenEditActionModal}
                    onClose={() => { onEditBodyMatrixClose()}}
                    >
                    <div className="modalBody modal-content" style={{ width: isMobile ? '80%' : 900, minHeight: 500 }}>
                            <Fragment>
                                <ModalHeading
                                    text={ `Edit PAR-Q` }
                                    closeModal={() => { onEditBodyMatrixClose()}}
                                />
                                <div className="modalContent">
                                <ParQ
                                        isEdit={true}
                                        clientEmail = {clientEmail}
                                        isOpenAddModal = { true }
                                        item = {range}
                                        parentData = { updateRange }
                                        hideActionModal = {() => {
                                            setOpenEditActionModal(false)
                                        }}
                                        isMobile = {isMobile}
                                        user = { props.user}
                                        savePARQ = { savePARQ}
                                />
                                </div>
                            </Fragment>
                    </div>
                    </Modal>
                )}

                <div className="assign-scroll" id = "scrollableActions" style={{
                    width: isMobile ? '320px' : '800px',
                    overflow: 'auto',
					height: 350
                }}>
                            { (isFetchRes && parqList.length === 0 ) &&
                                <div style={{ textAlign: 'center', width: isMobile ? '320px' : '750px', }}>
                                   <h1>No History Available!</h1>
                                </div>
                            }

                    <InfiniteScroll
                                    dataLength={parqList.length} //This is important field to render the next data
                                    next={() => fetchData(parqList.length)}
                                    hasMore={isLoadMore}
                                    scrollableTarget="scrollableActions"
                                    loader={
                                        <LoadMoreIcon/>
                                    }
                            >
                            {(parqList.length > 0 && !isMobile) &&
                                <Fragment>
                                <div  style={{
                                    marginLeft: '2px',
                                }}>
                                    <div
                                        className="link"
                                        style={{ float: 'left', width: isMobile ? '100px': '320px', display: 'block',  marginTop: '10px', marginTop: '10px', fontWeight: 'bold' }}
                                    > Assign
                                    </div>
                                    <div
                                        className="link"
                                        style={{ float: 'left', width: isMobile ? '100px': '250px', minHeight: '1', display: 'block',  marginTop: '10px', marginTop: '10px',  fontWeight: 'bold' }}
                                    > Complete
                                    </div>
                                   
                                        

                                </div>
                            </Fragment>
                            }
                            {parqList.map(range => (
                                <Fragment>
                                    { isMobile ? 
                                        <div  style={{
                                            marginLeft: '2px',
                                        }}>
                                             <div
                                                className="link"
                                                style={{ float: 'left', width: '185px', display: 'block',  marginTop: '10px', marginTop: '10px' }}
                                            >
                                                <div>
                                                    <span style={{ fontWeight: 'bold'}}>Assign: </span> 
                                                    <span>{
                                                        renderDate(range.createdAt)
                                                    }</span>
                                                </div>
                                              <div>
                                              <span style={{ fontWeight: 'bold'}}>Complete: </span> 
                                              <span>{
                                            range.completedDate ? renderDate(range.completedDate) : ''
                                          }</span>
                                              </div>
                                             </div>
                                             <div
                                                className="link"
                                                style={{ float: 'right', marginTop: '10px' }}
                                                onClick={() => deletePARQData(range._id)}
                                              >
                                                <FontAwesomeIcon icon={faTrash} title={'Delete'}
                                                    size='2x'
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                            </div>
                                            <div
                                                className="link"
                                                style={ { float: 'right', marginTop: '10px' }}
                                                onClick={() => showEditActionMode(range)}
                                              >
                                                <FontAwesomeIcon size='2x'  icon="edit" title={'Edit Action'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                            </div>
                                            { range.isCompleted &&
                                                <div
                                                    className="link"
                                                    style={{ float: 'right', marginTop: '10px' }}
                                                >
                                                    <FontAwesomeIcon size='2x'  icon={faCheck} title={'Completed'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                                </div>
                                            }   
    
    
                                        </div>
                                    :
                                    <div  style={{
                                        marginLeft: '2px',
                                    }}>
                                         <div
                                            className="link"
                                            style={{ float: 'left', width: '320px', display: 'block',  marginTop: '10px', marginTop: '10px' }}
                                        >{
                                            renderDate(range.createdAt)
                                          }
                                         </div>
                                         <div
                                            className="link"
                                            style={{ float: 'left', width: '250px', minHeight: '1', display: 'block',  marginTop: '10px', marginTop: '10px' }}
                                        >{
                                            range.completedDate ? renderDate(range.completedDate) : <div>&nbsp;</div>
                                          }
                                         </div>
                                         <div
                                            className="link"
                                            style={{ float: 'right', marginTop: '10px' }}
                                            onClick={() => deletePARQData(range._id)}
                                          >
                                            <FontAwesomeIcon icon={faTrash} title={'Delete'}
                                                style={{ marginRight: 5, color: COLORS.orange }} />
                                        </div>
                                        <div
                                            className="link"
                                            style={ { float: 'right', marginTop: '10px' }}
                                            onClick={() => showEditActionMode(range)}
                                          >
                                            <FontAwesomeIcon  icon="edit" title={'Edit Action'}
                                                style={{ marginRight: 5, color: COLORS.orange }} />
                                        </div>
                                        { range.isCompleted &&
                                            <div
                                                className="link"
                                                style={{ float: 'right', marginTop: '10px' }}
                                            >
                                                <FontAwesomeIcon  icon={faCheck} title={'Completed'}
                                                style={{ marginRight: 5, color: COLORS.orange }} />
                                            </div>
                                        }   


                                    </div>
                                    }
                                </Fragment>
                            ))}
                    </InfiniteScroll>
                </div>
            </div>
            </div>
        </Fragment>
    );
};

export default PARQListing;



// WEBPACK FOOTER //
// ./src/components/assignments/PARQListing.js